import axios from 'axios';
import { Action, createAction, handleActions } from 'redux-actions';
import { FULFILLED, PENDING, REJECTED } from './action-type.util';
import { IMonitoring as IModel } from './monitoring.model';
import { getAxiosData, getRejectedRespData, SERVER_API_URL } from '../config/constants';

export const ACTION_TYPES = {
    UPDATE_STATE: 'monitoring/UPDATE_STATE',
    GET: 'monitoring/GET',
};

export interface IMonitoringState {
    loading: boolean;
    error: any;
    data: IModel;
}

const initState = {
    loading: false,
    error: null,
    data: {} as IModel,
};

export const updateState = createAction(ACTION_TYPES.UPDATE_STATE);

export const get = createAction(ACTION_TYPES.GET, (params: any) =>
    getAxiosData(axios.get(`${SERVER_API_URL}/dashboard`, { params })),
);
/* Reducer function */
const onPending = (state: IMonitoringState): IMonitoringState => ({ ...state, loading: true });
// const onPendingCancel = (state: IMonitoringState): IMonitoringState => ({ ...state, loading: false });
const onRejected = (state: IMonitoringState, action: Action<any>): IMonitoringState => ({
    ...state,
    error: getRejectedRespData(action.payload),
    loading: false,
});
/* Reducer function end */

export default handleActions<IMonitoringState, any>(
    {
        [ACTION_TYPES.UPDATE_STATE]: (state: IMonitoringState, action: Action<any>): IMonitoringState => ({
            ...state,
            ...action.payload,
        }),

        [PENDING(ACTION_TYPES.GET)]: onPending,
        [REJECTED(ACTION_TYPES.GET)]: onRejected,
        [FULFILLED(ACTION_TYPES.GET)]: (state: IMonitoringState, action: Action<any>): IMonitoringState => ({
            ...state,
            loading: false,
            data: { ...action.payload },
        }),

        /* WS events */
        /* WS events end */
    },
    initState,
);
